import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetState } from '../../../store/actions';
import { RootState } from '../../../store/store';

export interface CustomersState {
  activeCustomerId: string | null;
}

const initialState: CustomersState = {
  activeCustomerId: null,
};

const customersSlice = createSlice({
  name: 'customers',
  initialState,
  reducers: {
    setActiveCustomerId: (state, { payload }: PayloadAction<string | null>) => {
      state.activeCustomerId = payload;
    },
  },
  extraReducers: builder => {
    builder.addMatcher(resetState.match, () => initialState);
  },
});

export const selectActiveCustomerId = (state: RootState) => state.customers.activeCustomerId;

export const { setActiveCustomerId } = customersSlice.actions;

const customersReducer = customersSlice.reducer;

export default customersReducer;
